import Vue from 'vue';
import VueLazyload from 'vue-lazyload';

import VueRouter from 'vue-router';

Vue.use(VueRouter);
Vue.use(VueLazyload, {
    preLoad: 1.1,
});


export default function createRouter() {
    const mode = EASY_ENV_IS_NODE ? 'abstract' : 'history';
    return new VueRouter({
        mode,
        routes: [
            // {
            //     path: '/photo/:authorId/:photoId',
            //     name: 'photo',
            //     component: () => import(/* webpackChunkName: 'photo' */ '@client/page/mobile/view/video/share/index.vue'),
            // },
            // {
            //     path: '/testphoto/:authorId/:photoId',
            //     name: 'testphoto',
            //     component: () => import(/* webpackChunkName: 'testphoto' */ '@client/page/mobile/view/video/share/index.vue'),
            // },
            // {
            //     path: '/user/:userId',
            //     name: 'user',
            //     component: () => import(/* webpackChunkName: 'user' */ '@client/page/mobile/view/user/share/index.vue'),
            // },
            // {
            //     path: '/testuser/:userId',
            //     name: 'testuser',
            //     component: () => import(/* webpackChunkName: 'testuser' */ '@client/page/mobile/view/user/share/index.vue'),
            // },
            {
                path: '/share/tag',
                name: 'tag',
                component: () => import(/* webpackChunkName: 'tag' */ '@client/page/mobile/view/tag/share/index.vue'),
            },
            {
                path: '/testshare/tag',
                name: 'testtag',
                component: () => import(/* webpackChunkName: 'testtag' */ '@client/page/mobile/view/tag/share/index.vue'),
            },
            // {
            //     path: '/live/share',
            //     name: 'sharelive',
            //     component: () => import(/* webpackChunkName: 'sharelive' */ '@client/page/mobile/view/live/share/index.vue'),
            // },
            {
                path: '/error',
                name: 'error',
                component: () => import(/* webpackChunkName: 'error' */ '@client/page/mobile/view/error/index.vue'),
            },
            {
                path: '/404',
                name: 'notfound',
                component: () => import(/* webpackChunkName: 'notfound' */ '@client/page/mobile/view/error/notfound/index.vue'),
            },
            {
                path: '/ug/search',
                name: 'search',
                component: () => import(/* webpackChunkName: 'search' */ '@client/page/mobile/view/seo/search/index.vue'),
            },
            {
                path: '/o/duet/:authorId/:photoId',
                name: 'duet',
                component: () => import(/* webpackChunkName: 'duet' */ '@client/page/mobile/view/duet/share/index.vue'),
            },
            // {
            //     path: '/one/features/share/profile/:userId',
            //     name: 'snackoldprofile',
            //     component: () => import(/* webpackChunkName: 'snackoldprofile' */ '@client/page/mobile/view/user/share/index.vue'),
            // },
            {
                path: '/one/features/share/tag/:tagName',
                name: 'snackoldhashtag',
                component: () => import(/* webpackChunkName: 'snackoldhashtag' */ '@client/page/mobile/view/tag/share/index.vue'),
            },
            {
                path: '/one/features/share/music/:musicId',
                name: 'snackoldmusic',
                component: () => import(/* webpackChunkName: 'snackoldmusic' */ '@client/page/mobile/view/tag/share/index.vue'),
            },
            // {
            //     path: '/on/snack/share',
            //     name: 'snackoldphoto',
            //     component: () => import(/* webpackChunkName: 'snackoldphoto' */ '@client/page/mobile/view/video/share/index.vue'),
            // },
        ],
    });
}
